import { Component, EventEmitter, Input, Output } from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-label-toggle',
  templateUrl: './label-toggle.component.html',
  standalone: true,
  imports: [
    CommonModule
  ],
  styleUrls: ['./label-toggle.component.scss']
})
export class LabelToggleComponent {
  @Input() active?: boolean;
  @Input() disabled?: boolean;
  @Input() readonly?: boolean;
  @Input() toggleStyle: 'checkbox' | 'point' | 'important' = 'point';
  @Output() activeChange = new EventEmitter<boolean>();

  onActiveClick() {
    if (!this.disabled && !this.readonly) {
      this.active = !this.active;
      this.activeChange.emit(this.active);
    }
  }
}
